import { remindersService } from 'config/api';
import { addNotification } from 'modules/shell/actions';
import actionTypes from './actionTypes';

export const fetchClientReminders = (profileId) => async (dispatch) => {
  try {
    dispatch({ type: actionTypes.GET_CLIENT_REMINDERS_LOADING });

    const { data } = await remindersService.get(`/reminders?profileId=${profileId}`);

    dispatch({
      type: actionTypes.GET_CLIENT_REMINDERS_SUCCESS,
      payload: data,
    });
  } catch (err) {
    const error = err.response?.data?.message || err.message;
    dispatch({
      type: actionTypes.GET_CLIENT_REMINDERS_ERROR,
      payload: error,
    });
  }
};

export const fetchClientReminder = (reminderId) => async (dispatch) => {
  try {
    dispatch({ type: actionTypes.GET_CLIENT_REMINDER_LOADING });

    const { data } = await remindersService.get(`/reminders/${reminderId}`);

    dispatch({
      type: actionTypes.GET_CLIENT_REMINDER_SUCCESS,
      payload: data,
    });
  } catch (err) {
    const error = err.response?.data?.message || err.message;
    dispatch({
      type: actionTypes.GET_CLIENT_REMINDER_ERROR,
      payload: error,
    });
  }
};

export const createClientReminder = (body) => async (dispatch) => {
  try {
    dispatch({ type: actionTypes.CREATE_CLIENT_REMINDER_LOADING });

    const { data } = await remindersService.post('/reminders/', body, { httpClientOptions: { handleErrors: false } });

    dispatch({
      type: actionTypes.CREATE_CLIENT_REMINDER_SUCCESS,
      payload: data,
    });
    dispatch(
      addNotification({
        id: `delete-${Date.now()}`,
        message: 'Reminder created',
        type: 'success',
      }),
    );

    return 'success';
  } catch (err) {
    const error = err.response?.data?.message || err.message;
    dispatch({
      type: actionTypes.CREATE_CLIENT_REMINDER_ERROR,
      payload: error,
    });

    dispatch(
      addNotification({
        id: `delete-${Date.now()}`,
        message: 'Reminder not created. Please try again.',
        type: 'error',
      }),
    );

    return 'error';
  }
};

export const updateClientReminder = (reminderId, body) => async (dispatch) => {
  try {
    dispatch({ type: actionTypes.UPDATE_CLIENT_REMINDER_LOADING });

    const { data } = await remindersService.put(`/reminders/${reminderId}`, body);

    dispatch({
      type: actionTypes.UPDATE_CLIENT_REMINDER_SUCCESS,
      payload: data,
    });

    return 'success';
  } catch (err) {
    const error = err.response?.data?.message || err.message;
    dispatch({
      type: actionTypes.UPDATE_CLIENT_REMINDER_ERROR,
      payload: error,
    });

    return 'error';
  }
};

export const deleteClientReminder = (reminderId) => async (dispatch) => {
  try {
    dispatch({ type: actionTypes.DELETE_CLIENT_REMINDER_LOADING });

    await remindersService.delete(`/reminders/${reminderId}`);

    dispatch({
      type: actionTypes.DELETE_CLIENT_REMINDER_SUCCESS,
      payload: { id: reminderId },
    });

    return 'success';
  } catch (err) {
    const error = err.response?.data?.message || err.message;
    dispatch({
      type: actionTypes.DELETE_CLIENT_REMINDER_ERROR,
      payload: error,
    });

    return 'error';
  }
};
